export default __webpack_public_path__ + "static/media/Calabrese-Large.4ae1db0e.jpg";